// Golf Cart Content
import GolfCartHero from '/assets/images/psp/hero/golf-cart-hero.webp';
import Featured1 from 'assets/images/psp/FeaturedImages/golfCartFeatured1.webp';
import Featured2 from 'assets/images/psp/FeaturedImages/car4.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/kayakFeatured2.webp';

const reviews = [
	{
		reviewTitle: 'Great location and easily accessible…',
		reviewRating: 5,
		reviewText:
			'SpareFoot found me a great location and easily accessible facility. The manager was honest and knowledgeable about the layout of the storage units. Cost is fairly reasonable.',
		reviewerInitials: 'RN',
		reviewerName: 'Reggie N',
		reviewDate: 'July 2, 2025',
		link: 'https://www.trustpilot.com/reviews/68641a442787f52521d81d18',
	},
	{
		reviewTitle:
			'Quick, easy, and affordable rental spaces. Browsing the website was easy.',
		reviewRating: 5,
		reviewText:
			'Browsing the website was easy! I found the perfect rental space quickly and for an amazing price.',
		reviewerInitials: 'LT',

		reviewerName: 'Laraine Tully',
		reviewDate: 'June 22, 2025',
		link: 'https://www.trustpilot.com/reviews/68581fda762f64442b52f591',
	},
	{
		reviewTitle: 'They found me a great place,',
		reviewRating: 5,
		reviewText:
			"They found me a great place for our things while moving. It's very affordable for any budget. No hassle and awesome online reminders of your reservations. Great company to work with. I 100% recommend this place.",
		reviewerInitials: 'JM',

		reviewerName: 'Jeremy Mohler',
		reviewDate: 'June 2, 2025',
		link: 'https://www.trustpilot.com/reviews/683dc6d2828f188da2bc9515',
	},
	{
		reviewTitle: 'All the storage options in one place.',
		reviewRating: 5,
		reviewText:
			'It was very helpful to see all the available storage options with all the price ranges & locations in one place! Thank you very much!!',
		reviewerInitials: 'JK',

		reviewerName: 'Janet K',
		reviewDate: 'Apr 1, 2025',
		link: 'https://www.trustpilot.com/reviews/67eb36e370a2e34d0b59e95b',
	},
];
const faqs = [
	{
		question: 'Can you store a golf cart outside in the winter?',
		answer: "Yes, but it's not ideal for long-term storage. While many golf carts can handle outdoor winter storage with proper preparation, you'll want to invest in a quality golf cart rain cover, remove batteries (for electric carts), and perform regular maintenance checks. Indoor storage eliminates these concerns and better protects your investment. If outdoor storage is your only option, look for facilities that offer covered parking or golf cart port structures.",
	},
	{
		question: "What's the ideal golf cart garage size for most carts?",
		answer: "Most standard 2-seater golf carts fit comfortably in a 10x10 storage unit, while 4-seaters typically need 10x12 or larger. However, if you've got a lifted cart, custom accessories, or want extra space for maintenance and storage of golf cart accessories, consider sizing up. Remember, you'll want enough room to walk around your cart and access all sides easily.",
	},
	{
		question: 'Do I need special insurance for stored golf carts?',
		answer: "Most storage facilities carry general liability insurance, but this doesn't cover your specific cart. Check with your homeowner's insurance to see if your golf cart is covered while in storage. Many policies include coverage for recreational vehicles, but it's worth confirming the details and considering additional coverage if you have a high-value cart.",
	},
	{
		question: 'How do I prepare my golf cart for storage?',
		answer: '**For electric carts:** Fully charge the battery, then disconnect and store in a dry location if storing long-term. Clean the cart thoroughly, check tire pressure, and remove any food or items that might attract pests.\n\n**For gas carts:** Add fuel stabilizer, change the oil if due, and run the engine briefly to circulate the treated fuel. Follow the same cleaning and inspection routine as electric carts.',
	},
	{
		question:
			'Are there storage sheds for golf carts I can buy instead of renting?',
		answer: "Yes. Storage sheds for golf carts are a great long-term investment if you have the space and local regulations allow. However, they typically cost $2,000-$8,000 upfront, require assembly, and may need permits. Renting storage gives you flexibility, professional security, and no maintenance responsibilities. Plus, if you move or sell your cart, you're not stuck with a shed you can't use.",
	},
];
export const GolfCartContent = {
	type: 'Golf Cart',
	sections: [
		{
			title: 'Golf Cart Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'golf-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Golf Cart Storage For You',
							description:
								"Don’t bogey your golf cart’s storage. Score a birdie or better with SpareFoot. We’ll connect you with secure, affordable golf cart storage options that'll keep your cart looking fresh and ready for action, rain or shine. \n\n From [climate-controlled indoor units](https://www.sparefoot.com/climate-controlled-storage.html) to covered outdoor spaces, we've got storage solutions that fit every budget and every cart size.",
							image: GolfCartHero,
							CTAText: 'Find Golf Cart Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					noPaddingBottom: true,
					background: 'gray',
					props: {
						title: 'Popular Golf Cart Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Golf Cart Storage Content',
			modules: [
				{
					title: 'Golf Cart Storage Content',
					type: 'content',
					props: {
						title: "Golf Cart Storage Unit Size Guide: Finding Your Cart's Perfect Home",
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'### Measure First to Understand Your Golf Cart Garage Size Needs\n\n' +
								"Measuring your golf cart before selecting a storage unit ensures you don't end up paying for a cramped space where you can't access your cart properly—or, worse yet, discover it doesn't fit at all after you've already signed the lease and moved it in.\n\n" +
								'### Tips for Measuring Your Golf Cart\n\n' +
								'- **Measure twice, store once:** Include any accessories like mirrors, windshields, or rear seats in your measurements.  \n' +
								"- **Don't forget the doors:** Factor in space to walk around your cart once it's parked.  \n" +
								'- **Think vertically:** Lifted carts or those with custom tops need extra headroom.  \n' +
								'- **Battery access:** If you have an electric cart, ensure you can easily reach the charging port.  \n' +
								"Not all golf carts are created equal, and neither are their storage spaces. Here's your cheat sheet for matching your ride with the right-sized unit:\n\n",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'golf-cart-size-chart',
						headers: [
							{
								label: 'Cart Type',
								key: 'Cart Type',
							},
							{
								label: 'Length',
								key: 'Length',
							},
							{
								label: 'Width',
								key: 'Width',
							},
							{
								label: 'Height',
								key: 'Height',
							},
							{
								label: 'Recommended Unit Size',
								key: 'Recommended Unit Size',
							},
							{
								label: 'Average Monthly Cost',
								key: 'Average Monthly Cost',
							},
						],
						rows: [
							{
								'Cart Type': '2-Seater Standard',
								Length: "8'",
								Width: "4'",
								Height: "6'",
								'Recommended Unit Size': {
									type: 'markdown',
									markdown:
										'[10x10](https://www.sparefoot.com/blog/10x10-storage-unit-size-guide)',
								},
								'Average Monthly Cost': '$85-$120',
							},
							{
								'Cart Type': '2-Seater Lifted',
								Length: "8'",
								Width: "4'",
								Height: "7'",
								'Recommended Unit Size': '10x10 (high ceiling)',
								'Average Monthly Cost': '$95-$135',
							},
							{
								'Cart Type': '4-Seater Standard',
								Length: "10'",
								Width: "4'",
								Height: "6'",
								'Recommended Unit Size': '10x12',
								'Average Monthly Cost': '$110-$150',
							},
							{
								'Cart Type': '4-Seater Lifted',
								Length: "10'",
								Width: "4'",
								Height: "7'",
								'Recommended Unit Size': '10x12 (high ceiling)',
								'Average Monthly Cost': '$125-$165',
							},
							{
								'Cart Type': '6-Seater',
								Length: "12'",
								Width: "4'",
								Height: "6'",
								'Recommended Unit Size': {
									type: 'markdown',
									markdown:
										'[10x15](https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit)',
								},
								'Average Monthly Cost': '$140-$180',
							},
							{
								'Cart Type': 'Utility Cart',
								Length: "9'",
								Width: "5'",
								Height: "6'",
								'Recommended Unit Size': '10x12',
								'Average Monthly Cost': '$115-$155',
							},
						],
					},
				},
			],
		},

		{
			title: 'Indoor vs. Outdoor Storage: The Ultimate Face-Off',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Indoor vs. Outdoor Storage: The Ultimate Face-Off',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'column-type',
						ShowBackgroundImage: true,
						content: [
							'### Indoor Storage \n\n' +
								'**Benefits**:\n\n' +
								'- Complete protection from weather, UV rays, and curious critters\n' +
								'- Climate-controlled options prevent battery degradation and interior damage\n' +
								'- Enhanced security with locked facilities and surveillance\n' +
								'- No need for additional golf cart rain cover investments\n' +
								'- Maintains resale value better than outdoor alternatives\n\n' +
								'**Best For:**\n\n' +
								'High-end carts, areas with harsh winters, or if you\'re storing long-term and want that "garage-kept" bragging rights.\n\n' +
								'**Average Cost:**\n\n' +
								'$85-$180/month, depending on size and location',
							'### Outdoor Storage\n\n' +
								'**Benefits**:\n\n' +
								'- More affordable than indoor options\n' +
								'- Easy drive-up access for quick trips\n' +
								'- Often includes covered parking or golf cart port structures\n' +
								'- Perfect for carts you use frequently\n' +
								'- Many facilities offer additional golf cart rain cover for extra protection\n\n' +
								'**Best For:**\n\n' +
								"Budget-conscious owners, frequent users, or those in milder climates where storing golf carts outside isn't as risky.\n\n" +
								'**Average Cost:**\n\n' +
								'$45-$95/month, depending on coverage level',
						],
					},
				},
			],
		},

		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: '37,000+ 5 Star Reviews From Storage Users Like You',
					},
				},
			],
		},
		{
			title: 'Frequently Asked Questions',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Golf Cart Storage FAQs',
						faqs,
					},
				},
			],
		},

		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'golf-cart-featured-content',
						contentCards: [
							{
								title: 'How to Store It',
								date: 'October 2, 2025',
								image: Featured1,
								content:
									'Golf Cart Storage Ideas: From DIY Covers to Custom Shed Solutions',
								link: 'https://www.sparefoot.com/blog/golf-cart-storage-ideas',
							},
							{
								title: 'General Storage Advice',
								date: 'September 26, 2025',
								image: Featured2,
								content:
									'Proper Storage Tips for Vehicle Batteries',
								link: 'https://www.sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries',
							},
							{
								title: 'General Storage Advice',
								date: 'October 24, 2025',
								image: Featured3,
								content:
									'How to Find The Right Storage Facility For Your Car, RV, or Boat',
								link: 'https://www.sparefoot.com/blog/how-to-find-the-right-storage-facility-for-your-car-rv-or-boat',
							},
						],
					},
				},
			],
		},

		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'ATV',
							'RV',
							'Car',
							'DriveUp',
							'24Hour',
							'ClimateControl',
							'Electricity',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
